import React, { lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import LoaderBox from './Components/LoaderBox/LoaderBox'
import './globals'
import './Style/styles.scss'
import './styles/branding.scss'
import './Utils/configurePdfWorker'
import { initSentry } from './Utils/sentry'
import { initTheme } from './Utils/theme'

initTheme()
initSentry().catch(() => {})

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {})
  })
}

const App = lazy(() => import('./App'))

const root = createRoot(document.getElementById('root'))

root.render(
  <Suspense fallback={<LoaderBox loader />}>
    <App />
  </Suspense>
)
